/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Currentuni1Inputs */

const en__field_currentuni1 = /** @type {(inputs: _Field_Currentuni1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`current college`)
};

const de__field_currentuni1 = /** @type {(inputs: _Field_Currentuni1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`derzeitige Hochschule`)
};

/**
* | output |
* | --- |
* | "current college" |
*
* @param {_Field_Currentuni1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_currentuni1 = /** @type {((inputs?: _Field_Currentuni1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Currentuni1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_currentuni1(inputs)
	return de__field_currentuni1(inputs)
});
export { _field_currentuni1 as "_field_currentUni" }